// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"268":"e60574b3","460":"3056d415","993":"04a0d08c"}[chunkId] + ".chunk.js";
};